import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, getDaysInMonth } from "date-fns";
import { useTranslation } from "react-i18next";
import { ImInfo } from "react-icons/im";
import Tooltip from '@material-ui/core/Tooltip';

import ButtonField from "../Fields/ButtonField";
import Col from "../Layout/Col";
import Row from "../Layout/Row";
import CalendarBody from "./CalendarBody";
import CreateEventCalendarBody from "./CreateEventCalendarBody";
import TimeLine from "./TimeLine";
import { getFullDayEvents, getTimeLineValues } from "../../helpers/calendarHelpers";
import {
    getCalendarSettings,
    getCalendarStartDate,
    getCreateEventMode,
    getWorkTimeEnd,
    getWorkTimeStart,
} from "../../redux/selectors/calendarSelectors";
import {
	getGrouppedTemplatesFilterOptions,
} from "../../redux/selectors/filterOptionsSelectors";
import {
	setCreateEventMode, setSelectedEventIdForPlanning,
	setSelectedTemplateId,
} from "../../redux/actions/calendarActions";
import {
    setCalendarDisplayTypeFilter,
    setPickedDateFilter,
} from "../../redux/actions/filterActions";
import Select from "react-select";
import {getBranchFilter, getTemplateGroupFilter} from "../../redux/selectors/filterSelectors";
import {filterTemplatesByBranchId} from "../../helpers/helpers";
import EventSort from "./EventSort";
import { getUser } from "../../redux/selectors/userSelectors";
import { getEvents } from "../../redux/selectors/eventsSelectors";

const MonthCalendar: FC = () => {
    const dispatch = useDispatch();
    const templateOpts = useSelector(getGrouppedTemplatesFilterOptions);
	const templateGroupId = useSelector(getTemplateGroupFilter);
    const branchId = useSelector(getBranchFilter);
    const calendarStartDate = useSelector(getCalendarStartDate);
    const workTimeStart = useSelector(getWorkTimeStart);
    const workTimeEnd = useSelector(getWorkTimeEnd);
    const createEventMode = useSelector(getCreateEventMode);
    const calendarSettings = useSelector(getCalendarSettings);
    const user = useSelector(getUser);
    const events = useSelector(getEvents);
    const daysInMonth = getDaysInMonth(calendarStartDate);
    const timeLineValues = getTimeLineValues(
        workTimeStart,
        workTimeEnd,
        "month",
        daysInMonth
    );
    const { t } = useTranslation();

    // const handleCreateEvent = () => {
    //     newEvent &&
    //         createEventFromAPI(newEvent)
    //             .then(() => {
    //                 // console.log("created event", newEvent);
    //             })
    //             .catch((err) => console.log(err));
    //     // TODO: update resources
    // };

    return (
        <div className="calendar-container">
            <div className="calendar-head">
                <Row>
                    <Col className="calendar-head-event">
                        <Row gap="5px">
                            {!createEventMode ? (
                                <Col>
                                    {user.facturabill_modify && (
                                        <Select
                                            placeholder={t("template")}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            options={filterTemplatesByBranchId(templateOpts, branchId, templateGroupId)}
                                            onChange={(val) => {
                                                dispatch(
                                                    // @ts-ignore
                                                    setSelectedTemplateId(val.value)
                                                );
                                                val &&
                                                dispatch(
                                                    setCreateEventMode(true)
                                                );
                                            }}
                                        />
                                    )}
                                    <EventSort />
                                    {/*<SelectField<string>*/}
                                    {/*    value={selectedTemplateId}*/}
                                    {/*    onChange={(val) => {*/}
                                    {/*        dispatch(*/}
                                    {/*            setSelectedTemplateId(val)*/}
                                    {/*        );*/}
                                    {/*        val &&*/}
                                    {/*            dispatch(*/}
                                    {/*                setCreateEventMode(true)*/}
                                    {/*            );*/}
                                    {/*    }}*/}
                                    {/*    label={t("template")}*/}
                                    {/*    options={templateOpts}*/}
                                    {/*/>*/}
                                </Col>
                            ) : (
                                <>
                                    {/*<Col>*/}
                                    {/*    <ButtonField*/}
                                    {/*        className="add-event-button"*/}
                                    {/*        onClick={handleCreateEvent}*/}
                                    {/*    >*/}
                                    {/*        {t("create_event")}*/}
                                    {/*    </ButtonField>*/}
                                    {/*</Col>*/}
                                    <Col>
                                        <ButtonField
                                            className="add-event-button"
                                            onClick={() => {
                                                dispatch(
                                                    setSelectedTemplateId(null)
                                                );
												dispatch(
													setSelectedEventIdForPlanning(null)
												);
                                                dispatch(
                                                    setCreateEventMode(false)
                                                );
                                            }}
                                        >
                                            {t("cancel")}
                                        </ButtonField>
                                        <EventSort />
                                    </Col>
                                </>
                            )}
                        </Row>
                    </Col>
                    {Array.from(Array(daysInMonth).keys()).map((day) => (
                        <Col
                            className="calendar-head-day"
                            key={day + 1}
                            onClick={() => {
                                dispatch(setCalendarDisplayTypeFilter("day"));
                                dispatch(
                                    setPickedDateFilter(
                                        new Date(
                                            new Date(calendarStartDate).setDate(
                                                day + 1
                                            )
                                        )
                                    )
                                );
                            }}
                        >
                            {format(
                                new Date(calendarStartDate).setDate(day + 1),
                                "EEEEEE"
                            )}
                            <br />
                            {day + 1}.
                            <br />
                            {getFullDayEvents(new Date(new Date(calendarStartDate).setDate(day + 1)), events).length > 0 && (
                                <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{
                                    getFullDayEvents(new Date(new Date(calendarStartDate).setDate(day + 1)), events).map((event, index) => (
                                        <span key={index}>{event.name}{"\n"}</span>
                                    ))
                                }</span>} arrow>
                                    <div>
                                        <ImInfo size="12px" style={{marginLeft: '5px', color: 'red'}} />
                                    </div>
                                </Tooltip>
                            )}
                        </Col>
                    ))}
                </Row>
            </div>
            <TimeLine timeLineValues={timeLineValues} />
            <div className="calendar-body-container">
                <div className="calendar-body">
                    <div className="body-timeline">
                        {timeLineValues.map((tl, index) => (
                            <React.Fragment key={index}>
                                {tl.showLine && (
                                    <div
                                        className="line"
                                        style={{
                                            marginLeft: `${tl.step}px`,
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                    {createEventMode ? (
                        <CreateEventCalendarBody />
                    ) : (
                        <CalendarBody />
                    )}
                </div>
            </div>
        </div>
    );
};

export default MonthCalendar;
